/**
 * Titre de l'accueil de l'assistant, tiré au hasard à chaque affichage selon l'heure, le jour et le
 * moment du mois (comme Claude). Vouvoiement, comme l'assistant ; sans prénom, les formules
 * personnelles sont omises.
 */
export function greetingsFor(now: Date, firstName: string): string[] {
  const h = now.getHours();
  const day = now.getDay();
  const date = now.getDate();
  const month = now.getMonth() + 1;
  const name = firstName.trim();
  const named = (text: string): string[] => (name ? [text] : []);

  const pool = [
    "Comment puis-je vous aider ?",
    "Que puis-je faire pour vous ?",
    "Par où commençons-nous ?",
    "Quel dossier ouvrons-nous ?",
    "Une question sur un chantier ?",
    "Une offre à chiffrer, une absence à poser ?",
    "Un PDF à classer ? Déposez-le ici.",
    "Je connais vos chantiers. Posez-moi la question.",
    "Que puis-je vous enlever des épaules ?",
    "Le métré, c'est vous. L'administratif, c'est moi.",
    "Moins de bureau, plus de chantier. Je vous écoute.",
    "La première pierre de la journée ?",
  ];

  if (h >= 5 && h < 11) {
    pool.push(
      ...named(`Bonjour ${name}, par quoi commençons-nous ?`),
      ...named(`Bonjour ${name}. Les camionnettes sont chargées ?`),
      "Que prévoyons-nous aujourd'hui ?",
      "Les équipes sont parties, à vous la suite.",
      "Café, planning, et c'est parti ?",
    );
  } else if (h >= 11 && h < 14) {
    pool.push(
      ...named(`Bon appétit, ${name}. Je garde la boutique.`),
      "Une question entre deux chantiers ?",
      "Pause de midi : avançons l'administratif ?",
      "Entre le plat du jour et le café, une facture à envoyer ?",
    );
  } else if (h >= 14 && h < 18) {
    pool.push(
      ...named(`Bon après-midi, ${name}.`),
      "Que reste-t-il à régler aujourd'hui ?",
      "Un devis à boucler avant ce soir ?",
      "Encore quelques heures avant de ranger les outils.",
    );
  } else if (h >= 18 && h < 22) {
    pool.push(
      ...named(`Bonsoir ${name}. Faisons le point sur la journée ?`),
      "Encore un peu d'administratif ce soir ?",
      "Les outils sont rangés. Il reste les factures ?",
    );
  } else {
    pool.push(
      ...named(`Encore debout, ${name} ?`),
      "Le chantier dort, pas les factures ?",
      "Même à cette heure, je suis là.",
      "Une idée à noter avant de dormir ?",
    );
  }

  if (day === 1) {
    pool.push(...named(`Bon début de semaine, ${name}.`), "Lundi : qui est sur quel chantier cette semaine ?");
  }
  if (day === 5) pool.push("Vendredi : bouclons la semaine ?", "Les heures de la semaine sont saisies ?");
  if (day === 6) pool.push(...named(`Samedi au bureau, ${name} ? Finissons vite.`));
  if (day === 0 || day === 6) pool.push("Même le week-end, je suis là.");
  if (date >= 25) pool.push("Fin de mois : les factures sont parties ?");
  if (date <= 3) pool.push("Début de mois : les salaires sont prêts ?");
  if (month === 12 || month <= 2) pool.push("Gel annoncé ? Revoyons le planning.");
  if (month === 6 || month === 7) pool.push("Vacances du bâtiment en vue ? Préparons les absences.");
  return pool;
}

export function pickGreeting(now: Date, firstName: string, random: () => number = Math.random): string {
  const pool = greetingsFor(now, firstName);
  return pool[Math.floor(random() * pool.length)];
}
